import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";
import { ScreenReaderLabel } from "@ww-digital/web-foundations-react/modules";
import cx from "classnames";

function RoundButton({
  onNext,
  isDisabled,
  onClick,
  children,
  size = "content",
  disabledText = "",
  pending,
  className,
  overrideClassName = null,
  ...others
}) {
  const handleClick = () => {
    if (isDisabled) {
      return;
    }

    onClick();
  };

  return (
    <button
      onClick={handleClick}
      type="button"
      className={
        overrideClassName
          ? overrideClassName
          : cx(styles.roundButton, className, styles[size], {
              [styles.disabled]: pending || isDisabled
            })
      }
      aria-disabled={isDisabled}
      disabled={pending || isDisabled}
      {...others}
    >
      {pending ? <div className={styles.spinner} /> : children}
      {isDisabled && <ScreenReaderLabel>{disabledText}</ScreenReaderLabel>}
    </button>
  );
}

RoundButton.propTypes = {
  size: PropTypes.oneOf(["fixed", "content"])
};

export default RoundButton;
